(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nav = document.getElementById('nav');
  if(nav){ window.addEventListener('scroll', function(){ nav.classList.toggle('scrolled', window.scrollY>10); }); }

  var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target);} }); }, {threshold:.14});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  if(!reduce && window.matchMedia('(hover:hover)').matches){
    document.querySelectorAll('.magnetic').forEach(function(el){
      el.addEventListener('mousemove', function(e){ var r=el.getBoundingClientRect(); el.style.transform='translate('+(e.clientX-r.left-r.width/2)*.25+'px,'+(e.clientY-r.top-r.height/2)*.35+'px)'; });
      el.addEventListener('mouseleave', function(){ el.style.transform=''; });
    });
  }

  var toast=document.getElementById('toast'), toastMsg=document.getElementById('toastMsg'), tTimer;
  function showToast(m){ if(!toast)return; toastMsg.textContent=m; toast.classList.add('show'); clearTimeout(tTimer); tTimer=setTimeout(function(){toast.classList.remove('show');},2200); }

  document.querySelectorAll('.faq-item').forEach(function(item){
    var q=item.querySelector('.faq-q'), a=item.querySelector('.faq-a');
    if(!q)return;
    q.addEventListener('click', function(){
      var open=item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); var aa=i.querySelector('.faq-a'); if(aa)aa.style.maxHeight=null; });
      if(!open){ item.classList.add('open'); a.style.maxHeight=a.scrollHeight+'px'; }
    });
  });

  // AJAX add to cart (progressive enhancement; falls back to normal submit)
  document.querySelectorAll('form.js-add').forEach(function(f){
    f.addEventListener('submit', function(e){
      var idEl=f.querySelector('[name=id]'); if(!idEl) return;
      e.preventDefault();
      var id=idEl.value;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){ if(!r.ok) throw 0; return fetch('/cart.js'); })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var cc=document.getElementById('cartCount');
          if(cc){ cc.textContent=cart.item_count; cc.classList.add('show'); cc.classList.remove('bump'); void cc.offsetWidth; cc.classList.add('bump'); }
          showToast('Aggiunto al carrello');
        })
        .catch(function(){ f.submit(); });
    });
  });
})();
